var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',[_vm._v(" "+_vm._s(_vm.$t('Invite your Facebook friends by sharing your personalized invitation link')))]),_c('b-button',{staticClass:"invite-facebook",on:{"click":_vm.inviteFacebook}},[_c('i'),_vm._v(" "+_vm._s(_vm.$t("Invite Facebook friends")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }